/**
 * Enemy level scaling — PROVISIONAL for enemyLevel >= 2.
 * enemyLevel === 1 is identity (exact M41 stats).
 * Do not treat Lv2+ curves as production balance.
 */

export interface EnemyLevelScale {
  hp: number
  reward: number
  /** Speed intentionally NOT scaled by difficulty*level blindly. */
  speed: number
  leakDamage: number
  shield: number
  regenHpPerSecond: number
}

/** Identity at Lv1. Provisional linear-ish curve for tests only. */
export function resolveEnemyLevelScale(enemyLevel: number): EnemyLevelScale {
  if (!Number.isFinite(enemyLevel) || enemyLevel < 1) {
    throw new Error(`Invalid enemyLevel: ${enemyLevel}`)
  }
  if (enemyLevel === 1) {
    return { hp: 1, reward: 1, speed: 1, leakDamage: 1, shield: 1, regenHpPerSecond: 1 }
  }
  // PROVISIONAL — not production balance.
  const t = enemyLevel - 1
  return {
    hp: 1 + t * 0.15,
    reward: 1 + t * 0.1,
    speed: 1,
    leakDamage: 1,
    shield: 1 + t * 0.15,
    regenHpPerSecond: 1 + t * 0.1
  }
}

/** Rank multipliers — NORMAL/BOSS identity for ACTIVE content. ELITE provisional. */
export function resolveEnemyRankScale(enemyRank: import('../types/primitives').EnemyRank): {
  hp: number
  reward: number
  armorValueBonus: number
} {
  switch (enemyRank) {
    case 'NORMAL':
      return { hp: 1, reward: 1, armorValueBonus: 0 }
    case 'BOSS':
      // Boss stats are authored on the definition; rank does not double-apply.
      return { hp: 1, reward: 1, armorValueBonus: 0 }
    case 'ELITE':
      // Production ELITE (M44 Flyer): +40% HP, +45% reward, light armor bump.
      return { hp: 1.4, reward: 1.45, armorValueBonus: 5 }
  }
}
